import { AlertCircle, WifiOff } from "lucide-react";

import type { UserFacingCellError } from "../types";

import { BasicTooltip } from "@/components/ui/Tooltip";

interface ErrorCellPreviewProps {
  userFacingError: UserFacingCellError;
}

export default function ErrorCellPreview({ userFacingError }: ErrorCellPreviewProps) {
  const Icon = userFacingError.isNetworkError ? WifiOff : AlertCircle;

  const content = (
    <div className="flex h-full min-h-0 w-full min-w-0 items-center gap-1.5 overflow-hidden bg-red-50/80 px-2 text-xs font-medium text-red-700 dark:bg-red-900/20 dark:text-red-400">
      <Icon className="h-3 w-3 flex-shrink-0" />
      <span className="truncate">{userFacingError.message}</span>
    </div>
  );

  return (
    <BasicTooltip content={userFacingError.message} side="top" delayDuration={400}>
      {content}
    </BasicTooltip>
  );
}
